//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.BaseDatumTarget.js";
let d=[[],[[[],"ConvertToPointTarget",{R_:{point_target:"Annotations.PointTarget"}},0,0],[[],"ConvertToLineTarget",{R_:{line_target:"Annotations.LineTarget"}},0,0],[[],"ConvertToAreaTarget",{R_:{rectangular_target:"Annotations.ArbitraryTarget"}},0,0],[[],"ConvertToDraftingPointTarget",{R_:{point_target:"Annotations.DraftingPointTarget"}},0,0],[[],"ConvertToDraftingLineTarget",{R_:{line_target:"Annotations.DraftingLineTarget"}},0,0],[[],"ConvertToDraftingAreaTarget",{R_:{rectangular_target:"Annotations.DraftingArbitraryTarget"}},0,0]],[]];
SPLM.Annotations.DraftingDatumTarget = class extends SPLM.Annotations.BaseDatumTarget{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.DraftingDatumTarget";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;